import { render, staticRenderFns } from "./Flatpickr.vue?vue&type=template&id=bf145b36&scoped=true"
import script from "./Flatpickr.vue?vue&type=script&lang=ts"
export * from "./Flatpickr.vue?vue&type=script&lang=ts"
import style0 from "./Flatpickr.vue?vue&type=style&index=0&id=bf145b36&prod&lang=scss&scoped=true"
import style1 from "./Flatpickr.vue?vue&type=style&index=1&id=bf145b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf145b36",
  null
  
)

export default component.exports